export const SearchResultsEmptyState = ({ search }: { search: string }) => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-2 p-6 text-center text-muted-foreground">
    <p className="text-sm font-medium">No matching ROs</p>
    <p className="text-xs">
      No cards match &ldquo;{search}&rdquo;. Try a different search term.
    </p>
  </div>
);
